import {
	clientDropDownSchema,
	templateDropDown,
	deviceTypeDropDownSchema,
} from 'validations/common';
import * as yup from 'yup';

yup.addMethod(yup.array, 'atleastOneImage', function (message) {
	return this.test('atleastOneImage', message, function (list) {
		console.log(list);
		let found = false;
		list.forEach((item) => {
			console.log('**', item);
			if (item.id > 0) {
				found = true;
			}
		});
		if (found) {
			return true;
		}

		return this.createError({ message });
	});
});

const advertisementAssetSchema = yup.object().shape({
	id: yup.number().when('type', {
		is: (value) => value === 'video' || value === 'image',
		then: yup
			.number()
			.required('Asset should be uploaded')
			.min(1, 'Asset should be uploaded'),
	}),

	children: yup.array().when('type', {
		is: (value) => value === 'multipleImages',
		then: yup.array().atleastOneImage('Atleast one image should be added.'),
	}),

	thumbnailAsset: yup.object().when('type', {
		is: (value) => value === 'video',
		then: yup.object().shape({
			id: yup
				.number()
				.required('Asset should be uploaded')
				.min(1, 'Asset should be uploaded'),
		}),
	}),
	bufferAsset: yup.object().when('type', {
		is: (value) => value === 'video',
		then: yup.object().shape({
			id: yup
				.number()
				.required('Asset should be uploaded')
				.min(1, 'Asset should be uploaded'),
		}),
	}),
});

export const advertisementSchema = yup.object().shape({
	name: yup.string().required('Advertisement Name is a mandatory field'),
	client: clientDropDownSchema,
	template: templateDropDown,
	deviceType: deviceTypeDropDownSchema,
	templateAssets: yup.array().of(advertisementAssetSchema),
});
